import Base, { ShippingStartProps, ShippingStartState } from 'core/pages/Shipping/ShippingStart'
import { Places, TmrPlace } from 'stylewhere/api'
import { FullLoadingLayer, InputModal, SelectItemModal } from 'stylewhere/components'
import { T, __ } from 'stylewhere/i18n'
import { FormSchemaData, Router } from 'stylewhere/shared'
import { showToastError } from 'stylewhere/utils'
import { retrieveDisposition } from './disposition'
import {
  ProductionOrderCandidate,
  requiresProductionOrderScan,
  retrieveProductionOrderBySerial
} from './productionOrder'

interface CustomShippingStartState extends ShippingStartState {
  resolvedProductionOrder?: ProductionOrderCandidate
  productionOrderCandidates?: ProductionOrderCandidate[]
  resolvedDestinationPlace?: TmrPlace
  resolvingProductionOrder?: boolean
}

export default class ShippingStart extends Base<ShippingStartProps, CustomShippingStartState> {
  state: CustomShippingStartState = {
    ...this.state
  } as any

  getExtraSubmitState(): Record<string, any> {
    return { resolvedProductionOrder: this.state.resolvedProductionOrder }
  }

  getInitialFormValues(): FormSchemaData | undefined {
    return this.state.resolvedDestinationPlace
      ? { asn: { destinationPlaceId: this.state.resolvedDestinationPlace } }
      : undefined
  }

  getExtraStartAttributes(): Record<string, any> {
    const attributes = this.state.resolvedProductionOrder
      ? { productionOrderRowId: this.state.resolvedProductionOrder.id }
      : {}
    console.log('[OTB-DEBUG] startParcel extra attributes', attributes)
    return attributes
  }

  onScanProductionOrderSerial = async (serial?: string) => {
    if (!serial) return
    this.setState({ resolvingProductionOrder: true })
    try {
      const candidates = await retrieveProductionOrderBySerial(this.operation, serial)
      console.log('[OTB-DEBUG] RETRIEVE_PRODUCTION_ORDER', { serial, candidates })
      if (!candidates?.length) {
        this.setState({ resolvingProductionOrder: false })
        showToastError(__('serverError.PRODUCTION_ORDER_NOT_FOUND'), __(T.error.error), this.isModal)
        return
      }
      this.setState({ productionOrderCandidates: candidates, resolvingProductionOrder: false })
    } catch (err) {
      this.setState({ resolvingProductionOrder: false })
      showToastError(err, __(T.error.error), this.isModal)
    }
  }

  onSelectProductionOrderCandidate = async (selected: ProductionOrderCandidate[]) => {
    const resolvedProductionOrder = selected[0]
    this.setState({ productionOrderCandidates: undefined, resolvingProductionOrder: true })
    let resolvedDestinationPlace: TmrPlace | undefined
    try {
      const disposition = await retrieveDisposition(this.operation, resolvedProductionOrder.id)
      console.log('[OTB-DEBUG] RETRIEVE_DISPOSITION', { productionOrderRowId: resolvedProductionOrder.id, disposition })
      if (disposition?.destinationPlaceCode) {
        const places = await Places.search<TmrPlace>({ equalCodes: disposition.destinationPlaceCode })
        resolvedDestinationPlace = places.content[0]
      }
    } catch (err) {
      showToastError(err, __(T.error.error), this.isModal)
    }
    // resolvedProductionOrder and resolvedDestinationPlace must land together: the start form
    // reads getInitialFormValues() only once, at mount, right when resolvedProductionOrder closes this gate
    console.log('[OTB-DEBUG] commessa selected', { resolvedProductionOrder, resolvedDestinationPlace })
    this.setState({ resolvedProductionOrder, resolvedDestinationPlace, resolvingProductionOrder: false })
  }

  public render() {
    if (requiresProductionOrderScan(this.operation) && !this.state.resolvedProductionOrder) {
      if (this.state.resolvingProductionOrder) {
        return <FullLoadingLayer />
      }
      if (this.state.productionOrderCandidates) {
        return (
          <SelectItemModal
            visible
            searchable
            size="3xl"
            title={__('otb_outbound.select_title')}
            options={this.state.productionOrderCandidates}
            field="productionOrder.code"
            onSelect={this.onSelectProductionOrderCandidate}
            onClose={() => this.setState({ productionOrderCandidates: undefined })}
          />
        )
      }
      return (
        <InputModal
          title={__('otb_outbound.scan_title')}
          labelInput={__('otb_outbound.scan_code_label')}
          onConfirm={this.onScanProductionOrderSerial}
          onClose={() => Router.navigate('/')}
        />
      )
    }
    return super.render()
  }
}
